<ion-content>
  <app-global-page-header
    [title]="
      brandOverride(
        'product.' + productClass!.getProductKey() + '.title' | translate
      )
    "
  >
    <div slot="end">
      <ion-button
        color="medium"
        fill="clear"
        shape="round"
        (click)="dismissModal()"
      >
        <i class="fa-solid fa-times"></i>
      </ion-button>
    </div>
  </app-global-page-header>

  <div class="p-3">
    <ion-label class="color-medium fw-bold">{{
      'assistance.step' + step | translate
    }}</ion-label>

    <div class="px-4 py-4 mt-3 box-white-rounded">
      @if (step === 0 || step === 1 || step === 2) {
        @if (showAssistanceReports.length === 0) {
          <div class="p-4">
            <p class="text-center">{{ 'assistance.noresult' | translate }}</p>
          </div>
        } @else {
          <ion-list lines="none">
            @for (report of showAssistanceReports; track report) {
              <ion-item
                type="button"
                class="pointer-hover"
                (click)="goTo(report)"
              >
                <ion-label>{{ brandOverride(report.title) }}</ion-label>
                <div slot="end">
                  <i class="fa-regular fa-chevron-right color-primary"></i>
                </div>
              </ion-item>
            }
          </ion-list>
        }
      } @else if (step === 3) {
        @if (showAssistanceCase?.media) {
          <img
            [src]="environment.backendUri + showAssistanceCase?.media"
            style="width: 100%; object-fit: contain; height: 300px"
          />
        }

        <h4>{{ brandOverride(showAssistanceCase?.title) }}</h4>
        <p>{{ brandOverride(showAssistanceCase?.content) }}</p>
      }
    </div>
  </div>
</ion-content>
